import { OtpGenerateViewModel } from '@apis/model/mfa/OtpGenerateViewModel';
import { toOtpTypeViewModel } from '@apis/responseTransformer/toOtpTypeViewModel';
import { toOtpViewModel } from '@apis/responseTransformer/toOtpViewModel';
import { InfoResponse } from '@ul/api';

export const toOtpGenerateViewModel = (response: InfoResponse): OtpGenerateViewModel => {
    const { success, responseCode } = response;
    return {
        success,
        responseCode,
        otpViewModel: toOtpViewModel(response),
        otpTypeViewModel: toOtpTypeViewModel(response),
    };
};
